export const NO_SORT = 'NO_SORT';
export const ASCENDING = 'ascending';
export const DESCENDING = 'descending';
